import React from 'react';

export default function FooterLinks() {
  return (
    <>
      <a href="https://library.clay.earth/" target="_blank">
        Help
      </a>
      &nbsp;&bull;&nbsp;
      <a href="https://clay.earth/terms" target="_blank">
        Terms
      </a>
      &nbsp;&bull;&nbsp;
      <a href="https://clay.earth/security-and-privacy" target="_blank">
        Privacy
      </a>
    </>
  );
}
